import { Body } from '@assembly-js/design-system';

import { InvoiceDraftDetailTypes } from 'src/features/assistant/action-item/BillingDraftWidget';
import { StripePaymentMethod } from 'src/types/payment';

export const BillingDraftSubtotal = ({
  billingDetails,
  source,
}: {
  billingDetails: InvoiceDraftDetailTypes;
  source?: StripePaymentMethod | string | null | undefined;
}) => {
  return (
    <div className="pl-14">
      <div className="border border-t border-x-0 border-b-0 border-non-hover-border border-solid w-full mb-2 mt-3" />
      <div className="flex flex-col gap-4 ">
        <div className="flex justify-between items-center text-black-heading">
          <Body size="sm">Subtotal</Body>
          <Body size="sm">{billingDetails.subTotal}</Body>
        </div>

        {Number(billingDetails.fee) > 0 && (
          <div className="flex justify-between items-center text-gray-small">
            <Body size="sm">
              {`${
                source === 'us_bank_account' ? 'ACH fee' : 'Credit card fee'
              } ${billingDetails.feeLabel ? `(${billingDetails.feeLabel})` : ''}`}
            </Body>
            <Body size="sm">
              {billingDetails.ignoreFees ? '- ' : billingDetails.fees}
            </Body>
          </div>
        )}
        {Number(billingDetails.taxAmount) > 0 && (
          <div className="flex justify-between items-center text-gray-small">
            <Body size="sm">
              {`Tax${
                Number(billingDetails.taxPercentage)
                  ? ` (${billingDetails.taxPercentage}%) `
                  : ''
              }`}
            </Body>
            <Body size="sm">{billingDetails.tax}</Body>
          </div>
        )}
      </div>
      <div className="border border-t border-x-0 border-b-0 border-non-hover-border border-solid w-full my-2" />
      <div className="flex justify-between items-center text-black-heading">
        <Body size="sm">Amount due</Body>
        <Body size="sm">{billingDetails.totalAmount}</Body>
      </div>
    </div>
  );
};
